import { render, staticRenderFns } from "./DepositView.vue?vue&type=template&id=63ec5caa&scoped=true"
import script from "./DepositView.vue?vue&type=script&lang=js"
export * from "./DepositView.vue?vue&type=script&lang=js"
import style0 from "./DepositView.vue?vue&type=style&index=0&id=63ec5caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec5caa",
  null
  
)

export default component.exports